import {Box, createStyles, Text} from '@mantine/core';
import React, {useState} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';

import {countGraphemes} from './GraphemeLimit';

const useStyles = createStyles((theme, {atLimit, visible}: {atLimit: boolean; visible: boolean}) => ({
  root: {
    '& > .editable': {
      outline: visible ? `2px solid ${atLimit ? theme.colors.red[6] : theme.colors.orange[6]}` : undefined,
      outlineOffset: visible ? 2 : undefined,
    },
  },
  counter: {color: atLimit ? theme.colors.red[6] : theme.colors.orange[7]},
}));

const GRAPHEME_LIMIT_FEEDBACK_PERCENT = 0.9;

export default function GraphemeLimitFeedback({
  text,
  maxGraphemes,
  children,
  locked,
}: {
  text: string;
  maxGraphemes: number;
  children: React.ReactNode;
  locked: boolean | undefined;
}): JSX.Element {
  const [inFocus, setInFocus] = useState(false);
  const count = countGraphemes(text);
  const atLimit = count >= maxGraphemes;
  const visible =
    !locked && inFocus && (atLimit || count >= Math.ceil(maxGraphemes * GRAPHEME_LIMIT_FEEDBACK_PERCENT));
  const {classes} = useStyles({atLimit, visible});
  return (
    <Box
      // Caller layout and styling stay on the editable child so they are not applied twice.
      className={classes.root}
      onFocus={() => {
        setInFocus(true);
      }}
      onBlur={(e: React.FocusEvent<HTMLDivElement>) => {
        if (!e.currentTarget.contains(e.relatedTarget as Node | null)) {
          setInFocus(false);
        }
      }}
      {...getTestProps({component: 'GraphemeLimitFeedback', element: 'root'})}
    >
      {children}
      {visible ? (
        <Text role="status" size="xs" className={classes.counter} mt="xs">
          {count} / {maxGraphemes} characters
        </Text>
      ) : null}
    </Box>
  );
}
